<template>
  <ul class="chat">
    <li class="chat_item" v-for="item of messages">
      <div class="message_box">
        <span class="name user">
          {{ userName }}
        </span>

        <p class="message user_message">
          {{ item.question }}
        </p>

        <span class="time user">
          {{ item.qCreatedAt ? getMessageTime(item.qCreatedAt) : "no time" }}
        </span>
      </div>

      <div class="message_box">
        <span v-if="item.type === 'bot'" class="name bot">{{
          "New Bot response"
        }}</span>

        <p class="message bot_message">
          {{ item.answer }}
        </p>

        <span class="time bot">
          <!-- <a class="link" href="">Still incorrect? Modify again!</a> -->
          <span>
            {{
              item.aCreatedAt ? getMessageTime(item.aCreatedAt) : "no time"
            }}</span
          ></span
        >
      </div>
    </li>
  </ul>
</template>

<script>
import getTime from "../../js/helpers/getTime";

export default {
  props: {
    messages: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
  },
  methods: {
    getMessageTime(messageTime) {
      return getTime(messageTime);
    },
  },
};
</script>

<style lang="scss" scoped>
.chat {
  color: #4f4f4f;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.chat_item {
  list-style: none;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message_box {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.name {
  font-weight: 500;
  line-height: 1.42;
}

.user {
  margin-right: auto;
}

.bot {
  margin-left: auto;
}

.time {
  font-size: 12px;
  line-height: 1.33;
  font-weight: 500;
}

.link {
  text-decoration: underline;
  color: #3056d3;
  margin-right: 7px;
}

.message {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  display: inline-block;
  padding: 12px 20px;
  max-width: 350px;
  word-wrap: break-word;
}

.user_message {
  margin-right: auto;
  background-color: #f4f7ff;
  border-radius: 0px 16px 16px 16px;
}

.bot_message {
  margin-left: auto;
  background-color: #3056d3;
  color: #fff;
  border-radius: 16px 16px 0px 16px;
}
</style>
